import React from 'react';
import { IconButton } from 'office-ui-fabric-react';
import { Tooltip } from '../Tooltip';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const ListingAction = _ref => {
  let {
    tooltipText,
    iconName,
    disabled,
    buttonStyles,
    onClick,
    dataId
  } = _ref;
  return /*#__PURE__*/_jsx(Tooltip, {
    tooltipBody: /*#__PURE__*/_jsx(_Fragment, {
      children: tooltipText
    }),
    children: /*#__PURE__*/_jsx(IconButton, {
      "data-id": dataId,
      iconProps: {
        iconName
      },
      disabled: disabled,
      styles: buttonStyles,
      onClick: onClick
    })
  });
};